import {
  LayoutDashboard, Package, Boxes, Users, Factory, FlaskConical, Leaf,
  Calculator, BrainCircuit, FileBarChart, Settings, ShoppingCart,
  Hammer, Droplets, Wind, ScrollText, UserCog,
} from "lucide-react";

// Each item: key, label, path, icon, roles (who can see). super_admin always sees all.
export const MENU = [
  { section: "Utama" },
  { key: "dashboard", label: "Dashboard", path: "/app/dashboard", icon: LayoutDashboard,
    roles: ["direktur", "akuntansi", "admin_produksi", "admin_material", "environmental_officer", "manajer_produksi"] },

  { section: "Master Data" },
  { key: "products", label: "Master Produk", path: "/app/master/produk", icon: Package,
    roles: ["akuntansi", "admin_produksi"] },
  { key: "materials", label: "Master Material", path: "/app/master/material", icon: Boxes,
    roles: ["admin_material", "akuntansi"] },
  { key: "labor", label: "Master Tenaga Kerja", path: "/app/master/tenaga-kerja", icon: Users,
    roles: ["akuntansi", "admin_produksi"] },
  { key: "overhead", label: "Master Overhead", path: "/app/master/overhead", icon: Factory,
    roles: ["akuntansi"] },
  { key: "emission", label: "Faktor Emisi", path: "/app/master/faktor-emisi", icon: FlaskConical,
    roles: ["environmental_officer"] },

  { section: "Transaksi" },
  { key: "orders", label: "Pesanan", path: "/app/pesanan", icon: ShoppingCart,
    roles: ["akuntansi", "admin_produksi", "direktur"] },
  { key: "batches", label: "Produksi", path: "/app/produksi", icon: Hammer,
    roles: ["admin_produksi", "manajer_produksi", "direktur"] },
  { key: "material-usage", label: "Material Usage", path: "/app/material-usage", icon: Droplets,
    roles: ["admin_material", "manajer_produksi"] },
  { key: "labor-cost", label: "Labor Cost", path: "/app/labor-cost", icon: Users,
    roles: ["akuntansi", "admin_produksi"] },
  { key: "overhead-cost", label: "Overhead Cost", path: "/app/overhead-cost", icon: Wind,
    roles: ["akuntansi"] },
  { key: "environmental-cost", label: "Environmental Cost", path: "/app/environmental-cost", icon: Leaf,
    roles: ["environmental_officer"] },

  { section: "Analisis" },
  { key: "hpp", label: "HPP Calculation", path: "/app/hpp", icon: Calculator,
    roles: ["akuntansi", "direktur"] },
  { key: "ai", label: "AI Analytics", path: "/app/ai", icon: BrainCircuit,
    roles: ["direktur", "manajer_produksi", "akuntansi"] },
  { key: "simulation", label: "Simulasi HPP", path: "/app/simulation", icon: FlaskConical,
    roles: ["direktur", "manajer_produksi", "akuntansi", "environmental_officer"] },
  { key: "reports", label: "Reports", path: "/app/reports", icon: FileBarChart,
    roles: ["akuntansi", "direktur", "environmental_officer", "manajer_produksi"] },

  { section: "Sistem" },
  { key: "users", label: "Manajemen User", path: "/app/users", icon: UserCog, roles: [] },
  { key: "settings", label: "Pengaturan", path: "/app/settings", icon: Settings, roles: [] },
  { key: "audit", label: "Audit Log", path: "/app/audit", icon: ScrollText, roles: ["direktur"] },
];

export function canSee(item, role) {
  if (!item.key) return true; // section header
  if (role === "super_admin") return true;
  return (item.roles || []).includes(role);
}

export const ROLE_LABELS = {
  super_admin: "Super Admin",
  direktur: "Direktur / Manajemen",
  akuntansi: "Akuntansi",
  admin_produksi: "Admin Produksi",
  admin_material: "Admin Material / Gudang",
  environmental_officer: "Environmental Officer",
  manajer_produksi: "Manajer Produksi",
};
